// eventually, this will spin up a comprehensive preview of the selected interaction and its children
// (possibly, it could just show a preview version of the entire editor in an iframe)
//  -- passing certain params to URL/iframe will render the editor in a different way
//  -- 'preview mode'
//  -- disables/hides all CRUD controls, top nav bar, breadcrumbs, any navigation
//  -- can still click through the tree as needed thoughimport * as React from "react";
import React from "react";

import Interval from "../../../models/communications/Interval";
import IntervalSet from "../../../models/communications/IntervalSet";

import Interaction from "../../../models/interactions/Interaction";
import ExistingInteractionPreview from "./preview/ExistingInteractionPreview";
import ExistingIntervalPreview from "./preview/ExistingIntervalPreview";
import ExistingIntervalSetPreview from "./preview/ExistingIntervalSetPreview";
import CommunicationSet from "../../../models/communications/CommunicationSet";
import ExistingCommSetPreview from "./preview/ExistingCommSetPreview";

export interface ExistingEntityPreviewProps {
  type: string;
  id: string | number;
  title: string;
  interaction?: Interaction;
  interval?: Interval;
  intervalSet?: IntervalSet;
  communicationSet?: CommunicationSet;
  intervalsForThisSet?: Array<Interval>;
  preview?: boolean;
}

const ExistingEntityPreview = (props: ExistingEntityPreviewProps) => {
  // FIXME -
  // right now the URL for the preview is always getting passed in as "s" (set)
  // it will need to be some combination of node and parent
  // and therefore we'll need to search for the interaction AND ALL corresponding nodes

  if (
    props.type == "intervalset" &&
    props.intervalSet &&
    props.intervalsForThisSet
  ) {
    return (
      <div>
        <ExistingIntervalSetPreview
          intervalsForThisSet={props.intervalsForThisSet}
          id={props.id}
          intervalSet={props.intervalSet}
        />
      </div>
    );
  }

  if (props.type == "interval" && props.interval) {
    return (
      <div>
        <ExistingIntervalPreview
          fromIntervalSet={false}
          interval={props.interval}
        />
      </div>
    );
  }

  if (props.type == "commset" && props.communicationSet) {
    return (
      <div>
        <ExistingCommSetPreview
          communicationSet={props.communicationSet} 
          type={"commset"} 
          id={props.communicationSet?.id || -1} 
          title={props.communicationSet?.name || ""} 
          preview={props.preview} />
      </div>
    );
  }

  // default to interaction preview
  return (
    <div>
      <ExistingInteractionPreview {...props} />
    </div>
  );
};

export default ExistingEntityPreview;
